<template>
  <a-card :bordered="false">

    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8" v-if="application.applicationType === 'platform'">
            <a-form-item :label="language['premission.applicationName']">
              <a-select v-model="queryParam.applicationId" allowClear >
                <a-select-option v-for="(application,index) in applicationList" :key="index.toString()" :value="application.id">
                  {{ application.applicationName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.header']">
              <a-input :placeholder="language['announcement.mustHeader']" v-model="queryParam.titile"></a-input>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="this.$store.getters.applicationCode === 'labor'">
            <a-form-item :label="language['system.labor.notice.category']"><!--公告类型-->
              <j-dict-select-tag  v-model="queryParam.laborAnnounceCategory" dictCode="labor_announce_category" :placeholder="this.language['common.pleaseChoose']+'公告类型'"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8" v-if="this.$store.getters.applicationCode === 'labor'">
            <a-form-item :label="language['announcement.sendStatus']"><!--发布状态-->
              <j-dict-select-tag  v-model="queryParam.sendStatus" dictCode="send_status" :placeholder="this.language['common.pleaseChoose']+'发布状态'"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <a-form-item :label="language['announcement.msgCategory']">
              <a-select
                v-model="queryParam.msgCategory"
                :placeholder="language['common.pleaseChoose']+language['announcement.msgCategory']"
                allowClear>
                <a-select-option value="1">{{language['announcement.notification']}}</a-select-option>
                <a-select-option value="2">{{language['announcement.systemMessages']}}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <!--<a-col :span="6">
            <a-form-item label="内容">
              <a-input placeholder="请输入内容" v-model="queryParam.msgContent"></a-input>
            </a-form-item>
          </a-col>-->

          <a-col :md="6" :sm="8">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>

        </a-row>
      </a-form>
    </div>

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'sysAnnouncement:insert'">{{language['common.insertButton']}}</a-button>
      <!--<a-button type="primary" icon="download" @click="handleExportXls('系统通告')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>-->
      <a-dropdown v-if="selectedRowKeys.length > 0" v-has="'sysAnnouncement:delete'">
        <a-menu slot="overlay" v-has="'sysAnnouncement:delete'">
          <a-menu-item key="1" @click="deleteRemove">
            <a-icon type="delete"/>
            {{language['common.delete']}}
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> {{language['common.batchAction']}}
          <a-icon type="down"/>
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> {{language['common.choosed']}} <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>{{language['common.item']}}
        <a style="margin-left: 24px" @click="onClearSelected">{{language['common.clear']}}</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys,selectionRows: selectionRows, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="msgCategory" slot-scope="text">
          <span v-if="text == '1'">{{language['announcement.notification']}}</span>
          <span v-else-if="text == '2'">{{language['announcement.systemMessages']}}</span>
          <span v-else>text</span>
        </template>
        <template slot="laborAnnounceCategory" slot-scope="text">
          <span v-if="text == '1'">{{language['system.labor.notice.training']}}</span><!--教育訓練-->
          <span v-else-if="text == '2'">{{language['system.labor.notice.regulations']}}</span><!--管理規章-->
          <span v-else-if="text == '3'">{{language['system.labor.notice.environmentReport']}}</span><!--作業環境檢測報告-->
          <span v-else-if="text == '4'">{{language['system.labor.notice.waterReport']}}</span><!--飲用水資質檢測報告-->
          <span v-else-if="text == '5'">{{language['system.labor.notice.guidelines']}}</span><!--承攬商入廠指引-->
        </template>
        <template slot="priority" slot-scope="text">
          <span v-if="text == 'L'">{{language['common.low']}}</span>
          <span v-else-if="text == 'M'">{{language['common.middle']}}</span>
          <span v-else-if="text == 'H'">{{language['common.high']}}</span>
        </template>
        <template slot="msgType" slot-scope="text">
          <span v-if="text == 'USER'">{{language['announcement.appointUser']}}</span>
          <span v-else-if="text == 'APPLICATION'">{{language['announcement.allUser']}}</span>
          <!--<span v-else>text</span>-->
        </template>
        <template slot="sendStatus" slot-scope="text">
          <span v-if="text == '0'">{{language['announcement.notPublish']}}</span>
          <span v-else-if="text == '1'">{{language['announcement.isPublish']}}</span>
          <span v-else-if="text='2'">{{language['announcement.isReovke']}}</span>
        </template>

        <span slot="action" slot-scope="text, record">
          <a  v-if="record.sendStatus == 0" @click="handleEdit(record)" v-has="'sysAnnouncement:edit'">{{language['common.edit']}}</a>

          <a-divider type="vertical" v-if="record.sendStatus == 0"  v-has="'sysAnnouncement:edit'"/>
          <a-dropdown>
            <a class="ant-dropdown-link">{{language['common.more']}} <a-icon type="down"/></a>
            <a-menu slot="overlay">
              <a-menu-item >
                <a href="javascript:;" @click="handleDetail(record)">{{language['common.detailsButton']}}</a>
              </a-menu-item>
              <a-menu-item v-if="record.sendStatus != 1" v-has="'sysAnnouncement:delete'">
                <a-popconfirm :title="language['common.deleteConfirmInfo']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => handleDelete(record.id)">
                  <a>{{language['common.delete']}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.sendStatus == 0" v-has="'sysAnnouncement:publish'">
                <a-popconfirm :title="language['announcement.surePublish']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => releaseData(record.id)">
                  <a>{{language['announcement.publishButton']}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.sendStatus == 1" v-has="'sysAnnouncement:reovke'">
                <a-popconfirm :title="language['announcement.sureReovke']" :okText="language['common.okButton']" :cancelText="language['common.cancel']" @confirm="() => reovkeData(record.id)">
                  <a>{{language['announcement.reovkeButton']}}</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item>
                  <a @click="handleShow(record)">{{language['common.look']}}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>
    <!-- table区域-end -->

    <!-- 表单区域 -->
    <sysAnnouncement-modal ref="modalForm" @ok="modalFormOk"></sysAnnouncement-modal>
    <!-- 查看详情 -->
    <j-modal class="detail-modal" :title="language['show.detail']" :visible.sync="detailModal.visible" :top="50" :width="600" switchFullscreen :footer="null">
      <iframe v-if="detailModal.url" class="detail-iframe" :src="detailModal.url"/>
    </j-modal>
    <show-announcement ref="ShowAnnouncement"></show-announcement>
  </a-card>
</template>

<script>
  import SysAnnouncementModal from './modules/SysAnnouncementModal'
  import {doReleaseData, doReovkeData,applicationList} from '@/api/api'
  import {getAction,httpAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import ShowAnnouncement from '@/components/tools/ShowAnnouncement'

  export default {
    name: "SysAnnouncementList",
    mixins: [JeecgListMixin],
    components: {
      SysAnnouncementModal,
      ShowAnnouncement
    },
    data() {
      return {
        description: '系统通告表管理页面',
        // 查询条件
        queryParam: {},
        detailModal: {visible: false, url: '',},
        url: {
          // list: "/sys/annountCement/list",
          list: this.$store.getters.application.applicationType=='platform'?"/sys/annountCement/list":"/sys/annountCement/list?applicationId="+this.$store.getters.application.id,
          delete: "/sys/annountCement/delete",
          deleteBatch: "/sys/annountCement/deleteBatch",
          releaseDataUrl: "/sys/annountCement/doReleaseData",
          reovkeDataUrl: "sys/annountCement/doReovkeData",
          exportXlsUrl: "sys/annountCement/exportXls",
          importExcelUrl: "sys/annountCement/importExcel",
        },
        application:{},
        applicationList:[],
      }
    },
    created () {
      // this.getThisapplication();
      this.application = this.$store.getters.application;
      if(this.application.applicationType === 'platform') {
        this.getApplicationList();
        let value = {
          title: this.$store.getters.language['announcement.secondMsgCategory'],
          align: "center",
          dataIndex: 'secondMsgCategoryName',
        }
        this.columns.splice(3,0,value);
      }else{
        //劳安专案排除
        if(this.$store.getters.applicationCode === 'labor'){
          return false;
        }
        getAction("/sys/sysleveldataconfigs/getDataByEntity",{applicationId:this.application.id,dataTypeCode:'announcement_management',parentCode:'1,2'}).then(res=>{
          if(res.success){
            let value = {
              title: this.$store.getters.language['announcement.secondMsgCategory'],
              align: "center",
              dataIndex: 'secondMsgCategoryName',
            }
            this.columns.splice(3,0,value);
          }
        })
      }

    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      columns() {
        let applicationCode = this.$store.getters.applicationCode;
        if (this.language && applicationCode != 'labor') {
          return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },

            {
              title: this.$store.getters.language['announcement.header'],
              align: "center",
              dataIndex: 'titile',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.$store.getters.language['announcement.msgCategory'],
              align: "center",
              dataIndex: 'msgCategory',
              scopedSlots: {customRender: 'msgCategory'},
              /*customRender: function (text) {
                if (text == '1') {
                  return this.$store.getters.language['announcement.notification'];
                } else if (text == "2") {
                  return this.$store.getters.language["announcement.systemMessages"];
                } else {
                  return text;
                }
              }*/
            },
            {
              title: this.$store.getters.language['announcement.publisher'],
              align: "center",
              dataIndex: 'sender'
            },
            {
              title: this.$store.getters.language['announcement.priority'],
              align: "center",
              dataIndex: 'priority',
              scopedSlots: {customRender: 'priority'},
              /*customRender: function (text) {
                if (text == 'L') {
                  return "低";
                } else if (text == "M") {
                  return "中";
                } else if (text == "H") {
                  return "高";
                } else {
                  return text;
                }
              }*/
            },
            {
              title: this.$store.getters.language['announcement.msgType'],
              align: "center",
              dataIndex: 'msgType',
              scopedSlots: {customRender: 'msgType'},
              /*customRender: function (text) {
                if (text == 'USER') {
                  return "指定用户";
                } else if (text == "ALL") {
                  return "全体用户";
                } else {
                  return "指定应用";
                }
              }*/
            },
            {
              title: this.$store.getters.language['announcement.sendStatus'],
              align: "center",
              dataIndex: 'sendStatus',
              scopedSlots: {customRender: 'sendStatus'},
            },
            {
              title: this.$store.getters.language['announcement.publishTime'],
              align: "center",
              dataIndex: 'sendTime'
            },
            {
              title: this.$store.getters.language['announcement.cancelTime'],
              align: "center",
              dataIndex: 'cancelTime'
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align: "center",
              scopedSlots: {customRender: 'action'},
            }
          ]
        } else if(this.language && applicationCode === 'labor') {
          return [
            {
              title: '#',
              dataIndex: '',
              key: 'rowIndex',
              width: 60,
              align: "center",
              customRender: function (t, r, index) {
                return parseInt(index) + 1;
              }
            },
            {
              title: this.$store.getters.language['announcement.header'],
              align: "center",
              dataIndex: 'titile'
            },
            {
              title: this.$store.getters.language['announcement.msgCategory'],
              align: "center",
              dataIndex: 'laborAnnounceCategory',
              scopedSlots: {customRender: 'laborAnnounceCategory'},
            },
            {
              title: this.$store.getters.language['announcement.priority'],
              align: "center",
              dataIndex: 'priority',
              scopedSlots: {customRender: 'priority'},
            },
            {
              title: this.$store.getters.language['announcement.sendStatus'],
              align: "center",
              dataIndex: 'sendStatus',
              scopedSlots: {customRender: 'sendStatus'},
            },
            {
              title: this.$store.getters.language['announcement.publishTime'],
              align: "center",
              dataIndex: 'sendTime'
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align: "center",
              scopedSlots: {customRender: 'action'},
            }
          ]
        }
      },
    },
    methods: {
      deleteRemove(){
        let selectionRows = this.selectionRows
        let boo = true;
        for(var i=0;i<selectionRows.length;i++){
          let data = selectionRows[i];
          if(data.sendStatus == 1){
            boo = false;
            this.$message.error(this.language["system.announcement.publishedInformationCannotDelete"])
            break;
          }
        }
        if(boo){
          this.batchDel()
        }
      },
      //初始化应用数据
      /*getThisapplication(){
        let param = {}
        param.code = this.$store.getters.applicationCode
        getAction("/sys/sysBmApplication/queryByCode", param).then((res) => {
          if (res.success) {
            this.application = res.result;
            if(res.result.applicationType === 'platform'){
              this.getApplicationList();
            }else{
              queryParam.applicationId=res.result.id
            }
          }
        })
      },*/
      getApplicationList(){
        httpAction("/sys/sysBmApplication/queryList", "", "get").then((res) => {
          if (res.success) {
            this.applicationList = res.result;
          }
        })
      },
      //执行发布操作
      releaseData: function (id) {
        console.log(id);
        var that = this;
        doReleaseData({id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      //执行撤销操作
      reovkeData: function (id) {
        var that = this;
        doReovkeData({id: id}).then((res) => {
          if (res.success) {
            that.$message.success(res.message);
            that.loadData(1);
            this.syncHeadNotic(id)
          } else {
            that.$message.warning(res.message);
          }
        });
      },
      syncHeadNotic(anntId){
        getAction("sys/annountCement/syncNotic",{anntId:anntId})
      },
      /*handleShow:function(record){
        const domain = window._CONFIG['domianURL']
        const token = this.$ls.get(ACCESS_TOKEN)
        this.detailModal.url = `${domain}/sys/annountCement/show/${record.id}?token=${token}`
        this.detailModal.visible = true
      },*/
      handleShow(record){
        this.$refs.ShowAnnouncement.detail(record,'SysAnnouncementlist');
        /*if(record.openType==='component'){
          this.openPath = record.openPage;
          this.formData = {id:record.busId};
          this.$refs.showDynamNotice.detail();
        }else{
          this.$refs.ShowAnnouncement.detail(record);
        }*/
      },
    }
  }
</script>
<style scoped lang="less">
  @import '~@assets/less/common.less';

  /** 查看详情弹窗的样式 */
  .detail-modal {
    .detail-iframe {
      border: 0;
      width: 100%;
      height: 88vh;
      min-height: 600px;
    }

    &.fullscreen .detail-iframe {
      height: 100%;
    }
  }

  .detail-modal /deep/ .ant-modal {
    top: 30px;

    .ant-modal-body {
      font-size: 0;
      padding: 0;
    }
  }

  .detail-modal.fullscreen /deep/ .ant-modal {
    top: 0;
  }

</style>